const { connect } = require('react-redux');
const debugComponent = require('./component').default;
const { actions } = require('../../reducers').default;
const objectType = require('../../define/object').default;
const playerType = require('../../define/player').default;
const { modalType } = require('../../define/screenType').default;
// ============================

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        onGameMount: () => {
            dispatch(actions.startGame(playerType.PLAYER_KAGEROU, "KG"));
        },
        onClickModal: () => {
            dispatch(actions.modalEnable(modalType.MODAL_GAME_OVER));
        },
        onClickSelector: index => {
            dispatch(actions.rotateBox(index));
        },
        onClickButton: () => {
            dispatch(actions.initStage(18));
            dispatch(actions.gameResume());
        },
        onTimeOut: () => {
            dispatch(actions.gameOver());
        },
        onDropPorinBox: (objectArray, frameId) => {
            dispatch(actions.placementBox(objectArray, frameId))
        },
        onDropSkill: objectArray => {
            dispatch(actions.placementSkill());
            dispatch(actions.doDamages(objectArray));
        },
        onDeleteItem: (posX, posY) => {
            dispatch(actions.deleteObject(posX, posY));
        },
        onPauseClick: () => {
            dispatch(actions.gamePause());
        },
        onClearStage: (bonus = 0) => {
            dispatch(actions.addScore(bonus));
            dispatch(actions.clearStage());
        },
        onClearGame: () => {
            dispatch(actions.gameClear());
        },
        onChainDamage: objectArray => {
            dispatch(actions.doDamages(objectArray));
        },
        onSkillCoolTimeEnd: () => {
            dispatch(actions.endCoolTime());
        },
        addScore: (point) => {
            dispatch(actions.addScore(point));
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps
    };
}

export const DebugContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(debugComponent);